export default "__VITE_ASSET__BX0FdN9P__"